import React from 'react';
import { Autocomplete } from '../../components/Autocomplete';
import styles from './search.module.css';
import '@algolia/autocomplete-theme-classic';
import { useHistory } from 'react-router-dom';
function SearchContainer() {
    var history = useHistory();
    return (React.createElement("div", { className: styles.search },
        React.createElement(Autocomplete, { placeholder: 'Search', openOnFocus: true, debug: true })));
}
export default SearchContainer;
